import Badge from '@repo/ui/badge'
import { Skeleton } from '@repo/ui/skeleton'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'

import { getTripFolderStats } from '../../../api/trip-folder/get-trip-folder-stats'

interface Props {
  folderId: number
}

const TripFolderStats = ({ folderId }: Props) => {
  const { data: tripFolderStats, isPending } = useQuery({
    queryKey: ['trip-folder-stats', folderId],
    queryFn: () => getTripFolderStats(folderId)
  })

  if (isPending) return <Skeleton className="w-2/3 h-10" />

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Typography variant="body-medium">Dossier Voyage</Typography>
      <Badge
        variant="fushia"
        text={`Nombre total de jeunes : ${tripFolderStats?.numberOfEnrollments}`}
      />
      <Badge
        variant="blue"
        text={`Nombre total d'encadrants : ${tripFolderStats?.numberOfStaffs}`}
      />
      <Badge
        variant="purple"
        text={`Nombre total d'AAT : ${tripFolderStats?.numberOfExternalStaffs}`}
      />
      <Badge
        variant="success"
        text={`Nombre total de bureau LEC : ${tripFolderStats?.numberOfLecStaffs}`}
      />
    </div>
  )
}

export default TripFolderStats
